import React, { memo, useCallback } from 'react';
import { Select } from 'antd';

import { classnames } from 'lib/classnames';
import useI18n from 'lib/hooks/useI18n';

import { useWorkspaceSelect } from './hooks';

import styles from './index.module.less';

const cx = classnames(styles);
interface WorkspaceSelectProps {
  onLoad?: (workspace: Parse.Attributes) => void;
  onWorkspaceChange: (workspace: Parse.Attributes) => void;
  initial?: string;
}

const WorkspaceSelect: React.FC<WorkspaceSelectProps> = ({ onWorkspaceChange, onLoad, initial }) => {
  const { t } = useI18n();

  const { data, options, loading, debounceFetcher, getWorkspaceDetail, fetchMore } = useWorkspaceSelect(
    initial,
    onLoad,
  );

  const onChange = useCallback(
    async (id: string) => {
      const workspaceDetail = await getWorkspaceDetail(id);
      onWorkspaceChange(workspaceDetail);
    },
    [getWorkspaceDetail, onWorkspaceChange],
  );

  const onPopupScroll = useCallback(
    event => {
      const currentTarget = event.target as HTMLElement;
      if (currentTarget.scrollTop + currentTarget.offsetHeight >= currentTarget.scrollHeight) {
        // more options
        fetchMore();
      }
    },
    [fetchMore],
  );

  return (
    <Select
      loading={loading}
      className={cx('select-item-content')}
      showSearch
      filterOption={false}
      onSearch={debounceFetcher}
      placeholder={t('pages.itemMove.selectItemType')}
      value={data?.objectId}
      onChange={onChange}
      options={options}
      onPopupScroll={onPopupScroll}
    />
  );
};

export default memo(WorkspaceSelect);
